import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faImage } from '@fortawesome/pro-light-svg-icons';
import { faPencil, faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { getImageDimensions } from '../../../foundation/utils/html.utils';
import { Button, Flag, Icon } from '../../index';
import { CARD_IMAGE_DEFAULT_PROP_HIDE_IMAGE, CARD_IMAGE_MAX_HEIGHT, CARD_IMAGE_MAX_WIDTH } from './Card.constants';
import { CardContent, CardContentActions, CardFlag, CardNoImage, CardRoot, CardWithImage, CardWrapper } from './Card.styled';
// Component.
// -----------------------------------------------------------------------------
const Card = forwardRef(({ children, deleteAction, editAction, flag, hideImage = CARD_IMAGE_DEFAULT_PROP_HIDE_IMAGE, image, selected, className }, ref) => {
    // Hooks.
    // -------------------------------------------------------------------------
    const [dimensions, setDimensions] = useState();
    // Helpers.
    // -------------------------------------------------------------------------
    const obtainImageDimensions = useCallback(async (url) => {
        try {
            const data = await getImageDimensions(url);
            setDimensions(data);
        }
        catch (ex) {
            console.group('Could not get image dimensions');
            console.log('URL: ', url);
            console.log('Exception: ', ex);
            console.groupEnd();
        }
    }, []);
    const renderImage = useCallback(() => {
        if (!image || !dimensions) {
            return (_jsx(CardNoImage, { children: _jsx(Icon, { icon: faImage, size: "5xl" }) }));
        }
        const isCover = dimensions.width >= CARD_IMAGE_MAX_WIDTH ||
            dimensions.height >= CARD_IMAGE_MAX_HEIGHT;
        return _jsx(CardWithImage, { isCover: isCover, url: image.url });
    }, [dimensions, image]);
    // Effects.
    // -------------------------------------------------------------------------
    useEffect(() => {
        if (!hideImage && !!image) {
            obtainImageDimensions(image.url);
        }
    }, [hideImage, image, obtainImageDimensions]);
    // Render
    // -------------------------------------------------------------------------
    return (_jsxs(CardWrapper, { className: `ui-card-wrapper ${className || ''}`.trim(), children: [flag && (_jsx(CardFlag, { children: _jsx(Flag, { ...flag }) })), _jsxs(CardRoot, { ref: ref, selected: selected, children: [!hideImage && renderImage(), _jsxs(CardContent, { selected: selected, hasImage: !hideImage && !!image, children: [_jsx("div", { children: children }), (!!editAction || !!deleteAction) && (_jsxs(CardContentActions, { children: [!!editAction && (_jsx(Button, { label: editAction.label, onClick: editAction.onClick, size: "xs", startIcon: faPencil, variant: "bare" })), !!deleteAction && (_jsx(Button, { label: deleteAction.label, schema: "negative", onClick: deleteAction.onClick, size: "xs", startIcon: faTrashCan, variant: "bare" }))] }))] })] })] }));
});
// Component configuration.
// -----------------------------------------------------------------------------
Card.displayName = 'Card';
export default Card;
//# sourceMappingURL=Card.js.map